// Types
import { PostDetails as PostDetailsType } from '../@codersclan/gatsby-theme-airfleet/@types/post';

export const getCategory = function getCategory(post: PostDetailsType) {
  if (post.nodeType === 'Post') {
    return {
      name: post.postCategories.nodes?.[0]?.name ?? 'Blog',
      slug: post.postCategories.nodes?.[0]?.slug ?? 'blog',
    };
  }
  return (
    post.categories.nodes?.[0] ?? {
      name: 'Uncategorized',
      slug: 'uncategorized',
    }
  );
};

export const getDefaultCategory = function getDefaultCategory(
  post: PostDetailsType,
) {
  if (post.nodeType === 'Post') {
    return {
      name: post.categories.nodes?.[0]?.name ?? 'Blog',
      slug: post.categories.nodes?.[0]?.slug ?? 'blog',
    };
  }
  return (
    post.categories.nodes?.[0] ?? {
      name: 'Uncategorized',
      slug: 'uncategorized',
    }
  );
};

export const getCtaLabel = function getCtaLabel(post: PostDetailsType) {
  const category = getCategory(post);
  switch (category.slug) {
    case 'ebook':
    case 'whitepapers':
    case 'reports':
      return 'DOWNLOAD NOW';
    case 'webinars':
      if (post.tags.nodes.some(a => a.name?.toUpperCase() === 'UPCOMING'))
        return 'REGISTER NOW';
      return 'WATCH NOW';
    default:
      return 'READ MORE';
  }
};
